import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-erv-low-leakage-dialog',
  templateUrl: './erv-low-leakage-dialog.component.html',
  styleUrls: ['./erv-low-leakage-dialog.component.scss'],
  standalone: false,
})
export class ErvLowLeakageDialogComponent implements OnInit {
  dataSource = [
    {
      model: 'MiniVent',
      lowLeakage: '',
    },
    {
      model: 'MiniCore',
      lowLeakage: '',
    },
    {
      model: 'ECV',
      lowLeakage: 'X',
    },
    {
      model: 'ERV',
      lowLeakage: 'X',
    },
    {
      model: 'ERVe',
      lowLeakage: 'X',
    },
    {
      model: 'ERVi',
      lowLeakage: 'X',
    },
  ];
  dataSourceExtra = [
    {
      model: 'MiniVent',
      terminalStrip: 'X',
      microprocessor: '',
      singleWall: 'X',
      doubleWall: '',
    },
    {
      model: 'MiniCore',
      terminalStrip: 'X',
      microprocessor: '',
      singleWall: 'X',
      doubleWall: '',
    },
    {
      model: 'ECV',
      terminalStrip: 'X',
      microprocessor: 'X',
      singleWall: 'X',
      doubleWall: 'X',
    },
    {
      model: 'ERV',
      terminalStrip: 'X',
      microprocessor: 'X',
      singleWall: 'X',
      doubleWall: 'X',
    },
    {
      model: 'ERVe',
      terminalStrip: 'X',
      microprocessor: 'X',
      singleWall: '',
      doubleWall: 'X',
    },
    {
      model: 'ERVi',
      terminalStrip: '',
      microprocessor: 'X',
      singleWall: '',
      doubleWall: 'X',
    },
  ];

  constructor(private dialogRef: MatDialogRef<ErvLowLeakageDialogComponent>) {}

  ngOnInit() {}

  closeClick() {
    this.dialogRef.close();
  }
}
